<template>
  <v-app>
    <!-- MENU LEFT -->
    <v-navigation-drawer right temporary fixed clipped v-model="drawer" app>
      <v-list dense>
        <template v-for="(menu, index) in menus">
          <v-list-tile v-if="!menu.childs" :key="index" :href="menu.link" exact>
            <v-list-tile-action>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ menu.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <div v-if="menu.childs" :key="index">
            <v-subheader class="mt-3">{{ menu.title }}</v-subheader>
            <v-divider></v-divider>
            <v-list-tile
              v-for="(submenu, subindex) in menu.childs"
              :key="subindex"
              :href="submenu.link"
            >
              <v-list-tile-action>
                <v-icon>{{ submenu.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ submenu.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
            <br />
          </div>
        </template>
      </v-list>
    </v-navigation-drawer>
    <!-- /MENU LEFT -->
    <!-- MENU TOP -->
    <v-toolbar flat dark class="top blue darken-4">
      <v-spacer class="hidden-md-and-down"></v-spacer>
      <v-toolbar-title class="white--text logo">
        <router-link :to="{ name: 'home' }">
          <img
            style="height:40px; margin:6px 0 0 0 !important;"
            src="/images/logo-com-slogan.svg"
            alt="Escola Engenho"
          />
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>

      <v-menu offset-y :open-on-hover="true">
        <template v-slot:activator="{ on }">
          <v-btn
            color="blue lighten-3"
            class="hidden-sm-and-down"
            dark
            round
            depressed
            outline
            v-on="on"
          >
            <span class>Portal do Aluno</span>
            <v-icon>arrow_drop_down</v-icon>
          </v-btn>
          <v-btn
            color="blue lighten-3"
            class="hidden-md-and-up"
            dark
            small
            fab
            depressed
            outline
            v-on="on"
          >
            <v-icon>face</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
            v-for="(o, i) in menus[0].childs"
            :key="i"
            :href="o.link"
          >
            <v-icon style="margin-right:5px;">{{ o.icon }}</v-icon>
            <v-list-tile-title>{{ o.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <v-tooltip bottom v-for="(icon, i) in sociais" :key="i">
        <template v-slot:activator="{ on }">
          <v-btn
            small
            fab
            depressed
            :color="icon.color"
            dark
            :href="icon.link"
            style="margin:0 2px;"
          >
            <i :class="icon.icon" style="font-size:22px"></i>
          </v-btn>
        </template>
        <span>Bottom tooltip</span>
      </v-tooltip>

      <!-- IDIOMAS -->
      <!-- <v-menu offset-y :open-on-hover="true">
        <template v-slot:activator="{ on }">
          <v-btn color="blue darken-4" small fab depressed v-on="on">
            <img :src="lang.icon" style="height:38px;">
          </v-btn>
        </template>
        <v-list>
          <v-list-tile v-for="(o, i) in langs" :key="i" @click="setLang(o)">
            <img :src="o.icon" style="height:30px; margin-right:5px;">
            <v-list-tile-title>{{ o.name }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu> -->
      <!-- /IDIOMAS -->

      <v-spacer class="hidden-md-and-down"></v-spacer>
    </v-toolbar>

    <!-- <v-toolbar flat dark class="down orange darken-1"> -->
    <v-toolbar flat dark class="down blue">
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <template v-for="(menu, index) in menus">
          <template v-if="!menu.top">
            <v-btn
              small
              v-if="!menu.childs"
              flat
              :key="index"
              :href="menu.link"
              exact
            >
              <v-icon style="margin-right:5px;">{{ menu.icon }}</v-icon>
              <span>{{ menu.title }}</span>
            </v-btn>
            <v-menu v-else offset-y :key="index" :open-on-hover="true">
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  :class="{
                    active: $router.currentRoute.meta.page === menu.name
                  }"
                  flat
                  v-on="on"
                >
                  <v-icon v-if="!menu.fa" style="margin-right:5px;">{{
                    menu.icon
                  }}</v-icon>
                  <i v-if="menu.fa" :class="menu.fa"></i>
                  <span>{{ menu.title }}</span>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile
                  v-for="(submenu, subindex) in menu.childs"
                  :key="subindex"
                  :href="submenu.link"
                >
                  <v-list-tile-title>
                    <v-icon v-if="!submenu.fa">{{ submenu.icon }}</v-icon>
                    <i
                      v-if="submenu.fa"
                      :class="submenu.fa"
                      style="margin-right:8px; color:#666;"
                    ></i>
                    {{ submenu.title }}
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </template>
        </template>
      </v-toolbar-items>

      <v-toolbar-side-icon
        @click.stop="drawer = !drawer"
        class="hidden-md-and-up"
      ></v-toolbar-side-icon>

      <v-spacer></v-spacer>
    </v-toolbar>

    <!-- /MENU TOP -->
    <v-content>
      <router-view />
    </v-content>
    <section class="footer">
      <!-- FOOTER 1 -->
      <Social />

      <!-- FOOTER 2 -->
      <section class="grey footer-2">
        <v-container fluid grid-list-md text-xs-center>
          <v-layout justify-center row wrap>
            <v-flex xs6 sm4 md2 lg2 v-for="(m, i) in menus" :key="i">
              <h4>
                <v-icon>{{ m.icon }}</v-icon>
                <br />
                {{ m.title }}
              </h4>
              <div v-if="m.childs">
                <v-btn
                  class="grey"
                  depressed
                  dark
                  small
                  block
                  v-for="(sm, y) in m.childs"
                  :key="y"
                  style="font-weight:400; text-transform:none"
                  :href="sm.link"
                  >{{ sm.title }}</v-btn
                >
              </div>
              <div v-if="!m.childs">
                <v-btn
                  class="grey"
                  depressed
                  dark
                  small
                  block
                  :href="m.link"
                  style="font-weight:400; text-transform:none"
                  >Acessar</v-btn
                >
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </section>

      <!-- FOOTER 3 -->
      <section class="grey darken-2 footer-3" style="color:#AAA;">
        <v-container grid-list-xl text-xs-center>
          <v-layout justify-center row wrap>
            <v-flex sm4>
              <h4>
                <v-icon>room</v-icon>
                <br />Endereço
              </h4>
              <p>
                Rua Valdomiro José Vieira, 94
                <br />Campeche - Florianópolis - SC <br />CEP 88063-035
              </p>
            </v-flex>
            <v-flex sm4>
              <h4>
                <v-icon>call</v-icon>
                <br />Telefone
              </h4>
              <p>
                (48) 3237-2410
                <br />(48) 99922-6535
                <i class="fab fa-whatsapp"></i>
              </p>
            </v-flex>
            <v-flex sm4>
              <h4>
                <v-icon>alternate_email</v-icon>
                <br />Email
              </h4>
              <p>engenho@escolaengenho.com.br</p>
            </v-flex>
          </v-layout>
        </v-container>
      </section>

      <!-- FOOTER 4 -->
      <section class="grey darken-3 footer-4" style="color:#AAA;">
        <v-container grid-list-xl text-xs-center>
          <v-layout row wrap>
            <v-flex sm12>
              <small>
                &copy;{{ year }} <strong>Escola Engenho</strong>. Desenvolvido
                com
                <v-icon style="font-size:1em; margin-right:3px; color:#E57373"
                  >favorite</v-icon
                >por
                <a
                  style="color:inherit; font-weight:bold; text-decoration:none;"
                  target="_blank"
                  href="http://epanel.com.br"
                  >Epanel Sistemas</a
                >.
              </small>
            </v-flex>
          </v-layout>
        </v-container>
      </section>
    </section>
  </v-app>
</template>

<script>
import Social from "./components/Social";

export default {
  name: "App",
  components: {
    Social
  },
  data() {
    return {
      year: new Date().getFullYear(),
      drawer: false,
      contacts: [],
      lang: { icon: "/images/pt.svg", name: "Português" },
      langs: [
        { icon: "/images/pt.svg", name: "Português" },
        { icon: "/images/en.svg", name: "Inglês" },
        { icon: "/images/es.svg", name: "Espanhol" }
      ],
      sociais: [
        {
          icon: "fab fa-facebook",
          link: "https://www.facebook.com/escolaengenhocampeche",
          text: "Curta no Facebook",
          color: "blue lighten-1"
        },
        {
          icon: "fab fa-instagram",
          link: "https://www.instagram.com/escolaengenho",
          text: "Siga no Instagram",
          color: "purple lighten-2"
        },
        {
          icon: "fab fa-whatsapp",
          link:
            "https://wa.me/5548999226535?text=Ol%C3%A1!%20Cheguei%20aqui%20atrav%C3%A9s%20do%20%20site%20da%20escola.",
          text: "Fale pelo WhatsApp",
          color: "green lighten-1"
        }
      ],
      menus: [
        {
          top: true,
          title: "Portal do Aluno",
          icon: "face",
          childs: [
            {
              title: "Alunos",
              icon: "face",
              link:
                "https://webserver.ciaporte.com.br/Engenho/login.xhtml?tipo=ALUNO"
            },
            {
              title: "Pais e Responsáveis",
              icon: "favorite",
              link:
                "https://webserver.ciaporte.com.br/Engenho/login.xhtml?tipo=RESPONSAVEL"
            },
            {
              title: "Professores",
              icon: "person",
              link:
                "https://webserver.ciaporte.com.br/Engenho/login.xhtml?tipo=PROFESSOR"
            },
            {
              title: "Coordenadores",
              icon: "folder_shared",
              link:
                "https://webserver.ciaporte.com.br/Engenho/login.xhtml?tipo=COORDENADOR"
            },
            {
              title: "Colaboradores",
              icon: "group",
              link:
                "https://webserver.ciaporte.com.br/Engenho/login.xhtml?tipo=COLABORADOR"
            },
            {
              title: "Consulta à Biblioteca",
              icon: "local_library",
              link: "https://webserver.ciaporte.com.br/Engenho/bbpesquisa.xhtml"
            },
            {
              title: "Autenticidade de Documentos",
              icon: "assignment_turned_in",
              link:
                "https://webserver.ciaporte.com.br/Engenho/autenticidade.xhtml"
            }
          ]
        },
        {
          top: false,
          title: "Segmentos",
          name: "solucoes",
          icon: "extension",
          childs: [
            {
              title: "Educação Infantil",
              icon: "child_care",
              fa: "fas fa-chess-pawn",
              link: "/segmentos/educacao-infantil"
            },
            {
              title: "Ensino Fundamental I",
              icon: "filter_1",
              fa: "fas fa-chess-bishop",
              link: "/segmentos/ensino-fundamental-1"
            },
            {
              title: "Ensino Fundamental II",
              icon: "filter_2",
              fa: "fas fa-chess-rook",
              link: "/segmentos/ensino-fundamental-2"
            }
          ]
        },
        {
          top: false,
          title: "Institucional",
          name: "solucoes",
          icon: "account_balance",
          childs: [
            {
              title: "História",
              icon: "history",
              link: "/institucional/historia"
            },
            {
              title: "Calendário Escolar",
              icon: "today",
              link: "/institucional/calendario"
            },
            {
              title: "Equipe",
              icon: "group",
              link: "/institucional/equipe"
            },
            {
              title: "Espaço Físico",
              icon: "domain",
              link: "/institucional/espaco-fisico"
            },
            {
              title: "Campanhas",
              icon: "movie",
              link: "/institucional/campanhas"
            },
            {
              title: "Material Publicitário",
              icon: "get_app",
              link: "/institucional/material-publicitario"
            },
            {
              title: "Lista de Materiais",
              icon: "list_alt",
              link: "/institucional/lista-de-materiais"
            },
            {
              title: "Seguro dos Alunos",
              icon: "security",
              link: "/institucional/seguro-dos-alunos"
            },
            {
              title: "Uniformes",
              icon: "how_to_reg",
              link: "/institucional/uniformes"
            },
            {
              title: "Download do Logotipo",
              icon: "cloud_download",
              link: "/institucional/logo"
            }
          ]
        },
        {
          top: false,
          title: "Pedagógico",
          name: "solucoes",
          icon: "school",
          obs: "",
          childs: [
            {
              title: "Proposta Pedagógica",
              icon: "stars",
              link: "/pedagogico/proposta"
            },
            {
              title: "Atividades Extracurriculares",
              icon: "directions_run",
              link: "/pedagogico/extracurriculares"
            },
            {
              title: "Convênios e Parcerias",
              icon: "card_giftcard",
              link: "/pedagogico/convenios"
            }
          ]
        },
        {
          top: false,
          title: "Espaço Físico",
          link: "/institucional/espaco-fisico",
          name: "home",
          icon: "camera_alt"
        },
        {
          top: false,
          title: "Atendimento",
          name: "solucoes",
          icon: "sms",
          childs: [
            {
              title: "Fale conosco",
              icon: "phone",
              link: "/atendimento/fale-conosco"
            },
            {
              title: "Localização",
              icon: "room",
              link: "/atendimento/localizacao"
            },
            {
              title: "Trabalhe conosco",
              icon: "person_add",
              link: "/atendimento/trabalhe-conosco"
            }
          ]
        }
      ]
    };
  },
  methods: {
    setLang: function(lang) {
      this.lang = lang;
    }
  }
};
</script>

<style lang="scss">
h1 {
  font-family: "Teko", sans-serif;
  text-align: center;
  color: #f4811e;
  span {
    color: #0094d9;
  }
  small {
    display: block;
    font-size: 0.8em;
  }
}

h2 {
  font-family: "Muli", sans-serif;
  font-weight: 400;
  line-height: 1.2em;
  text-align: left;
  font-size: 26px * 1.618;
  margin-bottom: 16px;
  small {
    line-height: 1.2em;
    display: block;
    font-size: 0.5em;
  }
}

h3 {
  font-size: 30px;
  .v-icon {
    font-size: 34px;
    margin-right: 10px;
  }
  a {
    text-decoration: none;
    .v-icon {
      color: #ef7e22 !important;
    }
  }
}

p,
ul li,
ol li {
  &.lead {
    font-size: 20px;
  }
  font-family: "Muli", sans-serif;
  font-weight: lighter !important;
  font-size: 16px;
  // text-align: left !important;
}
b {
  font-weight: bold;
}

.v-toolbar__title.logo {
  margin-left: 0px;
}

.footer {
  h4 {
    padding: 4px 0;
    text-transform: uppercase;
  }
  h4,
  i.v-icon {
    color: #98ddff;
  }
  i.v-icon {
    font-size: 3em;
  }
  .footer-2 {
    padding: 50px 0;
    h4,
    i.v-icon {
      padding-top: 10px;
      color: #dddddd;
    }
  }
  .footer-3 {
    padding: 35px 0;
    p {
      color: #ddd;
    }
    h4,
    i.v-icon {
      padding-top: 10px;
      color: #aaa;
    }
  }
}

.transparent {
  background: rgba(255, 255, 255, 0.9) !important;
}

.section {
  padding: 100px 0;
  background: #f5f5f5;
}

// XS
@media screen and (max-width: 600px) {
}

// SM
@media screen and (max-width: 960px) and (min-width: 601px) {
}

// MD
@media screen and (max-width: 1264px) and (min-width: 961px) {
}

// LG
@media screen and (max-width: 1904px) and (min-width: 1265px) {
}

// XL
@media screen and (min-width: 1905px) {
}
</style>
